<template>
  <template-info :bgImg="bgImg" title="ภาษีหัก ณ ที่จ่ายคืออะไร">
    <div>
      <div class="wtdb-detail">
        คือ เงินที่ผู้จ่ายเงินหักไว้ก่อนที่จะจ่ายให้กับผู้รับเงิน
        แล้วเอาเงินนั้นไปให้กับรัฐ ทำให้ผู้รับเงินไม่ได้รับเงิน เต็มจำนวน
        แต่จะได ้เงิน + กระดาษแผ่นนึงที่เรียกว่า หนังสือรับรองหัก ณ ที่จ่าย
        <br class="hide-on-desktop" />
        <br class="hide-on-desktop" />
        ส่วนผู้จ่ายเงินยังต้องจ่ายเต็ม เพียงแต่จ่ายให้กับ
        ผู้รับเงินโดยตรงส่วนนึง แล้วให้สรรพากรอีกส่วนนึง
      </div>

      <div class="wtdb-detail">
        <span>ยกตัวอย่าง</span> <br />
        นายเอ ตกลงจ่ายเงินค่าบริการสร้างเว็บไซต์ให้ นางสาวบี เป็นจำนวน 10,000
        บาท
      </div>

      <div class="wtdb-detail">
        โดยแบ่งเป็น จ่ายให้กับผู้รับเงินคือ <br />
        นางสาวบี 9,700 บาท และนำส่งสรรพากร 300 บาท
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/withholding_tax_definition.png";

export default {
  name: "WithholdingTaxDefinition",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {},
};
</script>

<style scoped>
.wtdb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.wtdb-detail > span {
  font-weight: bold;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .hide-on-desktop {
    display: none;
  }
}
</style>
